
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import OptimizerHero from './components/OptimizerHero';
import OptimizerFeatures from './components/OptimizerFeatures';
import OptimizerBenefits from './components/OptimizerBenefits';
import OptimizerUseCases from './components/OptimizerUseCases';
import OptimizerPricing from './components/OptimizerPricing';
import OptimizerCTA from './components/OptimizerCTA';
import Footer from '../home/components/Footer';

export default function PDFOptimizerPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    document.title = 'PDF Optimizer - 智能PDF压缩优化工具 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'PDF Optimizer提供专业的PDF文件压缩和优化功能，在保持文档质量的同时大幅减小文件体积，提升传输效率和存储空间利用率。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'PDF优化,PDF压缩,文件压缩,PDF瘦身,文档优化,PDF处理工具');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/pdf-optimizer`);

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "PDF Optimizer",
      "applicationCategory": "BusinessApplication",
      "description": "专业的PDF文件压缩和优化工具，在保持文档质量的同时大幅减小文件体积",
      "url": `${siteUrl}/pdf-optimizer`,
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "CNY",
        "price": "按需定制"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "63"
      },
      "provider": {
        "@type": "Organization",
        "name": "星允信息科技有限公司"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <OptimizerHero />
        <OptimizerFeatures />
        <OptimizerBenefits />
        <OptimizerUseCases />
        <OptimizerPricing />
        <OptimizerCTA />
      </main>
      <Footer />
    </div>
  );
}
